import { RightMenuStructure } from "../store";
import { RIGHT_MENU } from "../actions-constants/rightMenu.constants";

const initialRight:RightMenuStructure = new RightMenuStructure

export function rightMenuReducer(rightMenu: RightMenuStructure = initialRight,action):RightMenuStructure {
    switch(action.type) {
        case RIGHT_MENU.SHOW:
            return {...rightMenu,show: action.show}
        default:
            return rightMenu
    }
}